import {computed, onMounted, ref, nextTick} from 'vue'

const menu=ref([{name:'方案汇总',code:'project',type:'plan',icon:'',subName:'PROJECT SUMMARY'},
  {name:'案例视频',code:'case',icon:'',type:'video',subName:'CASE VIDEO'},
  {name:'演示体验',code:'demonstrated',type:'demo_web',icon:'',subName:'DEMONSTRATED EXPERIENCE'},
  {name:'资料下载',code:'data',icon:'',type:'information',subName:'DATA DOWNLOAD'}]);

let currMenu=ref({});

let showContent=ref(0);

let showDetail=ref(false);

let projects=ref([]);

let currProject=ref({});

const updateCurrMenu=function (menu) {
  if(menu && menu.code && menu.code!=''){
    currMenu.value=menu;
    showContent.value=1;
  }
  else{
    showContent.value=0;
    currMenu.value={};
  }
}



const updateCurrProject=function (item) {
  if(item && item.uuid && item.uuid!=''){
    currProject.value=item;
    showContent.value=2;
  }
  else{
    showContent.value=1;
    currProject.value={};
  }
}



export default {
  menu,
  currMenu,
  updateCurrMenu,
  showContent,
  showDetail,
  updateCurrProject,
  currProject,
  projects
}